import React from 'react';
import { useLang } from "../contexts/LanguageContext";
import Slider from 'react-slick';
import Book from './Book';

const Bookshelf = ({ label, books }) => {
  /* Inciar constante de traducción */
  const { t } = useLang();

  /* Configuración de Slick */
  const settings = {
    infinite: false,
    variableWidth: true,
    speed: 900,
    slidesToShow: 3,
    slidesToScroll: 3,
    draggable: true, 
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3 } },
      { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  };

  return (
    <div className="bookShelf" id={`bookShelf${label}`}>
      <div className="bookList" id={`bookList${label}`}>
        <Slider {...settings} className="bookSlider">
          {books.map((book) => (
            <div key={book.book_id}>
              <Book book={book} />
            </div>
          ))}
        </Slider>
      </div>

      <div className="bookShelf_label">
        <div className="bookShelf_title mx-auto">{t(label)}</div>
      </div>
    </div>
  );
};

export default Bookshelf;
